import { Stack, styled } from "@mui/material";

export const SavingsProductWrapper = styled(Stack)(({ theme }) => {
    return {
        gap: "var(--flex-gap)",
        overflow: "hidden",
        "& .savings-product-table-box": {
            "& .MuiTableContainer-root": {
                borderRadius: "16px",
                "& .MuiTableHead-root": {
                    "& .MuiTableCell-root": {
                        whiteSpace: "nowrap",
                    },
                    "& .MuiTableCell-root:last-child": {
                        width: "25%",
                    }
                }
            },
        },
    }
})